"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(palette) {
  return {
    color: palette.tFilled,
    fontSize: palette.tsLarge,
    lineHeight: palette.tlLarge,
    fontWeight: palette.twSemi,
    descriptionColor: palette.tInactive,
    descriptionFontSize: palette.tsSmall,
    descriptionLineHeight: palette.tlSmall,
    width: 'auto',
    minWidth: 'auto',
    iconMarginRight: palette.gutter * 2 + 'px'
  };
}